.button {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--spacing-sm);

    height: 50px;

    border: 1px solid var(--colorBorderPrimary);
    border-radius: 2rem;

    padding-inline: 1rem;

    background-color: var(--colorButtonSecondary);

    cursor: pointer;
}

.button[data-hovered],
.button[data-pressed] {
    border-color: var(--colorBorderSelected);
}

.button[data-focus-visible] {
    border-color: var(--colorBorderSelected);
    outline: 1px solid var(--colorBorderAccent);
    outline-offset: 1px;
}

.button[data-disabled] {
    cursor: default;
    background-color: var(--colorButtonDisabled);
}

.photo {
    flex: none;
}

.text {
    width: 100%;
    text-align: start;
    color: var(--colorTextPrimary);
    font-family: var(--fontFamilySansMedium), sans-serif;
    font-size: 14px;
}

.icon {
    flex: none;
    color: var(--colorTextPrimary);
}

.button[data-disabled] .text,
.button[data-disabled] .icon {
    color: var(--colorTextDisabled);
}
